// extracted by mini-css-extract-plugin
export default {"host":"style_host__zI0ry","small":"style_small__TWlXJ","middle":"style_middle__4b9ex"};